import { ToastService } from "angular-toastify";

// What went wrong with an API call, in words a user can act on.
//
// The HTTP interceptor passes a failed request on as either the API's validation errors - a 422, shaped
// { fieldName: ["message", ...] } - or the API's error message as a plain string. A response that didn't come
// through the interceptor is still an HttpErrorResponse, so that's read too.
export function ApiErrorMessages(err: any): string[] {
	if (!err) {
		return [];
	}

	if (typeof err === "string") {
		return err.trim() ? [err.trim()] : [];
	}

	if (Array.isArray(err)) {
		return unique(err.filter((m) => typeof m === "string"));
	}

	// An HttpErrorResponse: the API's body sits under error.response (or error, for older endpoints).
	if ("status" in err && "headers" in err) {
		const body = err.error?.response ?? err.error;
		if (body?.validationErrors) {
			return ApiErrorMessages(body.validationErrors);
		}
		return typeof body?.error === "string" ? ApiErrorMessages(body.error) : [];
	}

	if (err instanceof Error) {
		return ApiErrorMessages(err.message);
	}

	// Validation errors: every message for every field.
	return unique(Object.keys(err).reduce((messages: string[], field) => {
		const value = err[field];
		return messages.concat(Array.isArray(value) ? value : typeof value === "string" ? [value] : []);
	}, []));
}

// Toasts the API's reasons, or the fallback when the API gave none.
export function ToastApiError(toastService: ToastService, err: any, fallback = "Something Went Wrong!") {
	const messages = ApiErrorMessages(err);
	toastService.error(messages.length > 0 ? messages.join(" ") : fallback);
}

function unique(messages: string[]): string[] {
	return Array.from(new Set(messages.map((m) => m.trim()).filter(Boolean)));
}
